module.exports = __webpack_public_path__ + "img/exchange-alt.2551c213.svg";